import React from "react";

function normalizeTypeLabel(log) {
  const eventType = String(log?.eventType || "").trim().toUpperCase();

  if (eventType === "SOS") return "SOS";
  if (eventType === "SOS_DISMISS") return "SOS 해제";
  if (eventType === "HEART_RATE_HIGH") return "심박수 이상";
  if (eventType === "HEART_RATE_HIGH_DISMISS") return "심박수 이상 해제";

  return log?.type || "이벤트";
}

function isDangerLog(log) {
  const eventType = String(log?.eventType || "").trim().toUpperCase();

  if (
    eventType === "SOS" ||
    eventType === "HEART_RATE_HIGH" ||
    eventType === "PPE_VIOLATION"
  ) {
    return true;
  }

  const raw = `${log?.type || ""} ${log?.message || ""}`.toLowerCase();

  return (
    raw.includes("fire") ||
    raw.includes("화재") ||
    raw.includes("sos") ||
    raw.includes("위험") ||
    raw.includes("danger")
  );
}

export default function AlertPanel({ open, logs, onClose, onClear }) {
  if (!open) return null;

  return (
    <div className="fixed right-6 top-[88px] z-[99999] w-[390px] max-w-[calc(100vw-32px)] overflow-hidden rounded-3xl border border-gray-200 bg-white/98 shadow-[0_24px_80px_rgba(0,0,0,0.22)] backdrop-blur dark:border-white/10 dark:bg-[#111827]/98">
      <div className="flex items-center justify-between border-b border-gray-200 px-4 py-3 dark:border-white/10">
        <div>
          <div className="text-sm font-bold">실시간 알림</div>
          <div className="text-xs text-gray-500 dark:text-gray-400">
            최근 이벤트 {logs.length}건
          </div>
        </div>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={onClear}
            className="rounded-xl bg-gray-100 px-3 py-1.5 text-xs font-semibold text-gray-700 dark:bg-white/10 dark:text-gray-200"
          >
            읽음 처리
          </button>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-400 transition hover:text-gray-700 dark:hover:text-white"
          >
            ✕
          </button>
        </div>
      </div>

      <div className="max-h-[420px] overflow-y-auto p-3">
        {logs.length === 0 ? (
          <div className="py-8 text-center text-sm text-gray-500 dark:text-gray-400">
            새 알림이 없습니다.
          </div>
        ) : (
          <div className="space-y-3">
            {logs.map((log, idx) => {
              const danger = isDangerLog(log);

              return (
                <div
                  key={log?._key || idx}
                  className={`rounded-2xl border p-3 ${
                    danger
                      ? "border-red-200 bg-red-50 dark:border-red-800 dark:bg-red-950/30"
                      : "border-gray-200 bg-gray-50 dark:border-white/10 dark:bg-white/5"
                  }`}
                >
                  <div className="flex items-center justify-between gap-2">
                    <div
                      className={`text-sm font-semibold ${
                        danger
                          ? "text-red-700 dark:text-red-200"
                          : "text-blue-600 dark:text-blue-300"
                      }`}
                    >
                      {normalizeTypeLabel(log)}
                    </div>
                    <div className="text-[11px] text-gray-500 dark:text-gray-400">
                      {log?.displayTime || "-"}
                    </div>
                  </div>

                  <div className="mt-1 break-words text-sm text-gray-700 dark:text-gray-200">
                    {log?.message || "-"}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}